import {Component} from '@angular/core';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-conserverend-inkomen',
  templateUrl: './conserverend-inkomen.component.html',
  styleUrls: ['./conserverend-inkomen.component.scss'],
})
export class ConserverendInkomenComponent {
}
